
export const homeFaqs = [
  {
    id: 1,
    question: 'How much do bakkie removals cost in Durban?',
    answer: 'Our bakkie removal prices in Durban start from affordable rates with no hidden fees. The cost depends on the distance, volume of items, and specific requirements. Contact us for a free, transparent quote via WhatsApp or phone at 079 876 8956.',
  },
  {
    id: 2,
    question: 'Do you offer same-day removal services in Pinetown?',
    answer: 'Yes! We offer same-day bakkie removal services in Pinetown and surrounding areas, subject to availability. Contact us early in the day for the best chance of same-day service. We pride ourselves on flexible scheduling to meet your urgent moving needs.',
  },
  {
    id: 3,
    question: 'Are your vehicles insured for furniture transport?',
    answer: 'Absolutely. All our bakkie removal vehicles are fully insured, giving you complete peace of mind when transporting your furniture, appliances, and personal belongings across KwaZulu-Natal. Your items are protected throughout the journey.',
  },
  {
    id: 4,
    question: 'Which areas in KwaZulu-Natal do you service?',
    answer: 'We service all major areas across KwaZulu-Natal including Durban Central, Pinetown, Westville, Hillcrest, Umlazi, Phoenix, Chatsworth, and many rural areas. We specialize in both urban and rural transport services throughout KZN.',
  },
  {
    id: 5,
    question: 'Can you help with garden waste removal?',
    answer: 'Yes, through our Look Who\'s Landscaping division, we offer garden waste removal services along with landscaping, garden clean-ups, and compost delivery. We handle all types of garden waste efficiently and responsibly.',
  },
];

export const removalsFaqs = [
  {
    id: 1,
    question: 'What size items can you transport with your bakkie and trailer?',
    answer: 'Our bakkie with trailer can transport furniture, appliances, boxes, and various household items. We can handle couches, beds, fridges, washing machines, office furniture, and more. For very large items, contact us to discuss your specific needs.',
  },
  {
    id: 2,
    question: 'Do I need to pack my items before the removal?',
    answer: 'We recommend packing smaller items in boxes for safety and efficiency. However, we can assist with packing if needed. Our team handles all furniture and appliances with care, using protective materials to prevent damage during transport.',
  },
  {
    id: 3,
    question: 'How far in advance should I book a removal?',
    answer: 'We recommend booking at least 24-48 hours in advance for the best availability. However, we often accommodate same-day requests depending on our schedule. Contact us as soon as you know your moving date for guaranteed service.',
  },
  {
    id: 4,
    question: 'Do you provide long-distance removals outside Durban?',
    answer: 'Yes, we provide long-distance bakkie removals throughout KwaZulu-Natal, including rural areas. Whether you\'re moving from Durban to Pietermaritzburg or to smaller towns, we offer reliable transport services across the province.',
  },
  {
    id: 5,
    question: 'What payment methods do you accept?',
    answer: 'We accept cash, bank transfers, and electronic payments. Payment terms are discussed when you receive your quote. We believe in transparent pricing with no hidden fees, so you know exactly what you\'re paying for.',
  },
];

export const landscapingFaqs = [
  {
    id: 1,
    question: 'What landscaping services do you offer in Durban?',
    answer: 'Look Who\'s Landscaping offers complete garden solutions including professional landscaping design and installation, garden clean-ups, regular maintenance, compost supply and delivery, lawn care, and garden waste removal across Durban and KZN.',
  },
  {
    id: 2,
    question: 'How much does a garden clean-up cost?',
    answer: 'Garden clean-up costs vary based on the size of your garden and the amount of work required. We offer competitive, transparent pricing with no hidden fees. Contact us for a free quote via WhatsApp at 079 876 8956 or email bookings@lookwhosmoving.co.za.',
  },
  {
    id: 3,
    question: 'Do you deliver compost to residential properties?',
    answer: 'Yes, we deliver quality compost to residential and commercial properties throughout Durban, Pinetown, and surrounding KZN areas. Our compost is perfect for enriching your garden soil and promoting healthy plant growth.',
  },
  {
    id: 4,
    question: 'Can you maintain my garden on a regular basis?',
    answer: 'Absolutely! We offer regular garden maintenance services including lawn mowing, trimming, weeding, and general upkeep. We can arrange weekly, bi-weekly, or monthly visits based on your garden\'s needs and your budget.',
  },
  {
    id: 5,
    question: 'Do you remove garden waste after clean-ups?',
    answer: 'Yes, all garden waste is removed and disposed of responsibly as part of our service. We leave your property clean and tidy. Our team handles everything from small garden trimmings to large-scale clean-up projects.',
  },
];
